import { types } from '../../../constants/ActionTypes'
import { deepCopy, strToRenjuBoardCard } from '../../../lib';

const initialState = {
  records: [],
  editingBoardId: '',
  isFetching: false,
  ready: false,
}

const storeBoardCard = (state = initialState, action) => {
  var records, record
  switch (action.type) {
    case types.storeBoardCard.UNMOUNT:
      return { ...state, ready: false }
    case types.storeBoardCard.recordMenu.EDIT:
      return { ...state, editingBoardId: action.id }
    case types.webBoard.REFRESH:
      return { ...state, editingBoardId: '' }
    case types.fetch.board.RESPONSE_ADD:
      if (action.response.result === false) {
        return state
      }
      records = [deepCopy(action.response.record)]
      records[0].boardContext = records[0].boardContext ? strToRenjuBoardCard(records[0].boardContext) : undefined
      return { ...state, records: records.concat(state.records), editingBoardId: action.response.record.id }
    case types.fetch.board.RESPONSE_UPDATE:
      if (
        action.response.result === false &&
        !state.records.some((rc) => rc.id === action.response.record.id)
      ) {
        return state
      }
      record = action.response.record
      return {
        ...state,
        records:
          state.records.map((rc) => {
            if (rc.id === record.id) {
              return {
                ...rc,
                ...record,
                title: record.title !== undefined ? record.title : rc.title,
                boardContext: record.boardContext ?
                  strToRenjuBoardCard(record.boardContext) : rc.boardContext,
              }
            }
            return rc
          })
      }
    case types.fetch.board.RESPONSE_SELECT:
      if (action.response.result === false) {
        return state
      }
      records = deepCopy(action.response.records)
      records = records.map((record) => {
        return {
          ...record,
          boardContext: record.boardContext ? strToRenjuBoardCard(record.boardContext) : undefined
        }
      })
      records = records.filter((record) => record.boardContext !== undefined)
      records.sort((a, b) => {
        let datetimeA = a.updateDatetime ? a.updateDatetime : a.createDatetime
        let datetimeB = b.updateDatetime ? b.updateDatetime : b.createDatetime
        if (datetimeA > datetimeB) {
          return false
        }
        else {
          return true
        }
      })
      return { ...state, records, ready: true }
    case types.fetch.board.RESPONSE_DELETE:
      if (action.response.result === false) {
        return state
      }
      return { ...state, records: state.records.filter((record) => record.id !== action.response.id)}
    default:
      return state
  }
}

export default storeBoardCard


// WEBPACK FOOTER //
// ./src/reducers/Page/WebBoard/StoreBoardCard.js